import {
  StatusPublishedDotIcon,
  StatusActiveDotIcon,
  StatusDraftDotIcon,
  StatusInactiveDotIcon,
} from '../../../../../shared/ui/icons';
import { TEMPLATE_STATUS } from '../../../constants/messageTemplateKeys';
import { normalizeStatusKey } from '../lib/normalizeStatusKey';

export function StatusDot({ status }) {
  const key = normalizeStatusKey(status);

  if (key === TEMPLATE_STATUS.PUBLISHED) {
    return <StatusPublishedDotIcon />;
  }

  if (key === TEMPLATE_STATUS.ACTIVE) {
    return <StatusActiveDotIcon />;
  }

  if (key === TEMPLATE_STATUS.INACTIVE) {
    return <StatusInactiveDotIcon />;
  }

  if (key === TEMPLATE_STATUS.DRAFT) {
    return <StatusDraftDotIcon />;
  }

  return null;
}
